export default __webpack_public_path__ + "assets/1fe2c922249212124de2f452178c3ac0.svg";